module.exports = __webpack_public_path__ + "static/media/image-edit.57b4c2ee.svg";